export default {
    "h0": {
        variant: "subtitle1",
        rowHeight: 25
    },
    "d0": {
        variant: "caption",
        rowHeight: 30
    },
    "eol": {
        variant: "caption",
        rowHeight: 20
    }
}


// WEBPACK FOOTER //
// ./src/app/configuration/Demo/InvestorServices/config/components/scorecard/MetricsLabels/rowTypeMap.js